import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export interface HrListTab {
  key: string;
  label: string;
  icon: string;
  badge?: string | number;
}

@Component({
  selector: 'app-hr-list-tabs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './hr-list-tabs.component.html',
  styleUrls: ['./hr-list-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HrListTabsComponent {
  @Input() tabs: HrListTab[] = [];
  @Input() activeTab = '';
  @Output() activeTabChange = new EventEmitter<string>();

  selectTab(key: string): void {
    if (key !== this.activeTab) {
      this.activeTabChange.emit(key);
    }
  }
}
